import { render } from "./StudySettings.vue?vue&type=template&id=6e562ae8&scoped=true"
import script from "./StudySettings.vue?vue&type=script&lang=js"
export * from "./StudySettings.vue?vue&type=script&lang=js"

import "./StudySettings.vue?vue&type=style&index=0&id=6e562ae8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e562ae8"]])

export default __exports__